const e = "teaser", t = "teaser__overline", r = "teaser__title", a = "teaser__icon", _ = "teaser__description", s = "teaser__border", i = "teaser__video", n = {
  teaser: e,
  "teaser__media-container": "teaser__media-container",
  "teaser__link-wrapper": "teaser__link-wrapper",
  "teaser__visually-hidden": "teaser__visually-hidden",
  "teaser__image-border": "teaser__image-border",
  teaser__overline: t,
  "teaser__overline-element": "teaser__overline-element",
  teaser__title: r,
  "teaser__title--small": "teaser__title--small",
  teaser__icon: a,
  teaser__description: _,
  teaser__border: s,
  "teaser__buttons-wrapper": "teaser__buttons-wrapper",
  "teaser__buttons-wrapper--align-left": "teaser__buttons-wrapper--align-left",
  "teaser--card": "teaser--card",
  "teaser--unpublished": "teaser--unpublished",
  "teaser--in-draft": "teaser--in-draft",
  "teaser__image--loaded": "teaser__image--loaded",
  "teaser__image--reduced-scale": "teaser__image--reduced-scale",
  teaser__video: i
};
export {
  n as default,
  e as teaser,
  s as teaser__border,
  _ as teaser__description,
  a as teaser__icon,
  t as teaser__overline,
  r as teaser__title,
  i as teaser__video
};
